
export default {
  download: '다운로드',
}
